import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { SharedModule } from './../shared-module/shared.module';
import { ChartsModule } from '@cpd-app/shared-module/components/charts/charts.module';
import { OccupationSharedModule } from '@cpd-app/shared-module/components/occupation/occupation-shared.module';
import { CopyButtonComponent } from '@cpd-app/shared-module/components/copy-button/copy-button.component';
import { SimilarMilitaryOccupationsModule } from '@cpd-app/shared-module/components/similar-military-occupations/similar-military-occupations.module';
import { ChatViaModule } from '@cpd-app/features/chat-via/chat-via.module';

import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
// GR-15. Standalone; the header mounts it so the 3/3 counter can raise it.
import { GoalSetDialogComponent } from '@cpd-app/features/academic-goal/components/goal-set-dialog/goal-set-dialog.component';
import { SaveSessionDialogComponent } from './components/save-session-dialog/save-session-dialog.component';
import { TeamDialogComponent } from './components/team-dialog/team-dialog.component';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';
import { GoalDialogComponent } from './components/goal-dialog/goal-dialog.component';
import { SavedForLaterDialogComponent } from './components/saved-for-later-dialog/saved-for-later-dialog.component';
import { FeedbackComponent } from './components/feedback-dialog/feedback/feedback.component';
import { ReportIssueComponent } from './components/feedback-dialog/report-issue/report-issue.component';
import { AlertComponent } from './components/alert/alert.component';
import { TutorialDialogComponent } from './components/tutorial-dialog/tutorial-dialog.component';
import { TutorialButtonComponent } from './components/tutorial-button/tutorial-button.component';
import { PasscodeComponent } from './components/passcode/passcode.component';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { NotificationDrawerComponent } from './components/notification-drawer/notification-drawer.component';
import { NotificationPopoverComponent } from './components/notification-popover/notification-popover.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ViaButtonComponent } from './components/via-button/via-button.component';
import { NotEnoughCreditDialogComponent } from './components/not-enough-credit-dialog/not-enough-credit-dialog.component';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';

@NgModule({
  imports: [
    A11yModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    OccupationSharedModule,
    SharedModule,
    ChartsModule,
    CopyButtonComponent,
    SimilarMilitaryOccupationsModule,
    NgOptimizedImage,
    ChatViaModule,
    CdkMenuItem,
    CdkMenuTrigger,
    CdkMenu,
    GoalSetDialogComponent
  ],
  declarations: [
    TeamDialogComponent,
    FeedbackDialogComponent,
    FeedbackComponent,
    ReportIssueComponent,
    FooterComponent,
    HeaderComponent,
    GoalDialogComponent,
    SaveSessionDialogComponent,
    SavedForLaterDialogComponent,
    AlertComponent,
    TutorialDialogComponent,
    TutorialButtonComponent,
    PasscodeComponent,
    LoginDialogComponent,
    NotificationDrawerComponent,
    NotificationPopoverComponent,
    NotEnoughCreditDialogComponent,
    SidebarComponent,
    ViaButtonComponent
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    AlertComponent,
    TutorialButtonComponent,
    SidebarComponent,
    ViaButtonComponent
  ]
})
export class CoreModule {}
